// @ts-nocheck
import {
    CartLineModel,
    OrderLineModel,
    ProductModel,
    WishListLineModel,
} from "@insite/client-framework/Types/ApiModels";
import { trackViewStoreCart } from "@store/Framework/Common/GoogleAnalytics/hooks";
import { dcneAvailability } from "@store/Framework/Common/GoogleAnalytics/mappers";
import { viewMinicart } from "@store/Framework/Common/GoogleAnalytics/trackers";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { RecursivePartial } from "@toolkit/Framework/Types/Common";

const baseGA = { ...ga };

Object.assign<Toolkit.GoogleAnalytics, RecursivePartial<Toolkit.GoogleAnalytics>>(ga, {
    track: {
        ...ga.track,
        viewMiniCart: viewMinicart,
    },
    use: {
        ...ga.use,
        trackViewStoreCart,
    },
    map: {
        ...ga.map,
        dcneAvailability,
        cartLineModel: (cartLine: CartLineModel, options?: Toolkit.GoogleAnalytics.Options) => {
            const baseData = baseGA.map.cartLineModel(cartLine, options);
            return { ...baseData, ...ga.map.dcneAvailability(cartLine.properties?.availabilityStatus) };
        },
        orderLineModel: (orderLine: OrderLineModel, options?: Toolkit.GoogleAnalytics.Options) => {
            const baseData = baseGA.map.orderLineModel(orderLine, options);
            return { ...baseData, ...ga.map.dcneAvailability(orderLine.properties?.availabilityStatus) };
        },
        productModel: (product: ProductModel, options?: Toolkit.GoogleAnalytics.Options) => {
            const baseData = baseGA.map.productModel(product, options);
            return { ...baseData, ...ga.map.dcneAvailability(product.properties?.availabilityStatus) };
        },
        wishListLineModel: (wishListLine: WishListLineModel, options?: Toolkit.GoogleAnalytics.Options) => {
            const baseData = baseGA.map.wishListLineModel(wishListLine, options);
            return { ...baseData, ...ga.map.dcneAvailability(wishListLine.properties?.availabilityStatus) };
        },
    },
});
